import React, { createContext, useState, useEffect } from "react";
import { authenticationService } from "../api/authentication.service";

export const UserContext = createContext({
  user: null,
  loading: true,
});

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Primero, definimos una función async para esperar el refresco si es necesario.
    const rehydrateSession = async () => {
      const currentUser = JSON.parse(localStorage.getItem("currentUser"));
      // Si hay currentUser pero no hay token en memoria, refrescamos.
      if (currentUser && !window._accessToken) {
        try {
          await authenticationService.refreshToken();
        } catch (err) {
          console.error("Error refresh token", err);
        }
      }
      setLoading(false);
    };

    rehydrateSession();

    const subscription = authenticationService.currentUser.subscribe((data) => {
      if (data && data.user) {
        setUser(data.user);
      } else {
        setUser(null);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <UserContext.Provider value={user}>
      {children}
    </UserContext.Provider>
  );
};
